import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { NavData } from "../utils/navdata";
import MenuList from "./MenuList";
import Panel from "./Panel";
import * as AiIcons from "react-icons/ai";

const menuParent = {
  animate: {
    transition: {
      staggerChildren: 0.1,
      delayChildren: 1,
    },
  },
};

const Menu = ({ setMenuState, menuState }: any) => {
  const [isMobile, setIsMobile] = useState(false);

  const closeMenu = () => {
    setMenuState(!menuState);
  };

  useEffect(() => {
    if (window.innerWidth <= 480) {
      setIsMobile(true);
    } else setIsMobile(false);
  }, []);

  return (
    <AnimatePresence>
      {menuState && (
        <>
          <motion.div
            className="menu-container"
            initial={{
              visibility: "hidden",
            }}
            animate={{
              visibility: "visible",
              transition: { delay: 1 },
            }}
            exit={{
              visibility: "hidden",
              transition: { delay: 1 },
            }}
          >
            <Link className="menu-title" to="/">
              {!isMobile ? "Andrew Dikianidis" : "[d]"}
            </Link>
            <div className="close-menu-btn" onClick={() => closeMenu()}>
              <AiIcons.AiOutlineClose />
            </div>
            <div className="menu">
              <div className="container">
                <div className="menu-inner">
                  <motion.ul
                    variants={menuParent}
                    initial="initial"
                    animate="animate"
                    exit="exit"
                  >
                    {NavData?.map((item) => (
                      <MenuList
                        key={item.id}
                        leftLineFlex={item.leftLineFlex}
                        rightLineFlex={item.rightLineFlex}
                        title={item.name}
                        id={item.id}
                      />
                    ))}
                  </motion.ul>
                </div>
              </div>
            </div>
          </motion.div>
          <Panel />
        </>
      )}
    </AnimatePresence>
  );
};

export default Menu;
